import { extend } from 'vee-validate';
import { ValidationUtil } from '../util/validation/validation.util';

extend('cnpj', value => {
  if(ValidationUtil.cnpjValidation(value)) {
    return true;
  }
  return 'Este cnpj é inválido';
});
